import React from "react";
import {IndexZsmsSection1} from "./section1/IndexZsmsSection1";
import {BizVideoBackgroundZsms} from "../../shares/zsms/bizVideoBackground/bizVideoBackgroundZsms";

export const IndexZsms = () => {
    return (
        <IndexZsmsSection1/>
    );
};